import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "permissions-group" }
const _hoisted_2 = ["value", "label"]
const _hoisted_3 = { class: "flex-auto w-3/5 mr-4" }
const _hoisted_4 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_InertiaLink = _resolveComponent("InertiaLink")!
  const _component_ElDivider = _resolveComponent("ElDivider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_AclLayout = _resolveComponent("AclLayout")!

  return (_openBlock(), _createBlock(_component_AclLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_InertiaLink, {
            href: "/acl/groups",
            class: "block w-full mb-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "small",
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Вернуться назад")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ElDivider),
          _createVNode(_component_el_form, {
            model: _ctx.form,
            onSubmit: _withModifiers(_ctx.submit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Название группы",
                error: _ctx.errors.name
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["error"]),
              _createVNode(_component_el_form_item, {
                label: "Псевдоним",
                error: _ctx.errors.slug
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.slug,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.slug) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["error"]),
              _createVNode(_component_el_form_item, {
                label: "Описание",
                error: _ctx.errors.description
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.description,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.description) = $event)),
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["error"]),
              _createVNode(_component_el_collapse, {
                accordion: "",
                class: "mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_collapse_item, {
                    title: "Права группы",
                    class: "px-2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("datalist", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissions, (title, name) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: name,
                            value: name,
                            label: title
                          }, null, 8, _hoisted_2))
                        }), 128))
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.permissions, (entry, entryIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: entryIndex,
                          class: "flex border rounded p-2.5"
                        }, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_el_input, {
                              modelValue: entry.name,
                              "onUpdate:modelValue": ($event: any) => ((entry.name) = $event),
                              list: "permissions-group",
                              type: "input",
                              placeholder: "example.permission.name",
                              required: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createVNode(_component_el_button, {
                            class: "flex-initial ml-auto",
                            type: "danger",
                            "native-type": "button",
                            size: "small",
                            required: "",
                            onClick: ($event: any) => (_ctx.removePermission(entryIndex))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" × ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_button, {
                          class: "w-full",
                          type: "primary",
                          "native-type": "button",
                          onClick: _ctx.addNewPermission
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" + Добавить ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { class: "text-center -mx-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    class: "mx-1",
                    onClick: _ctx.submit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Сохранить")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_InertiaLink, {
                    href: '/acl/groups/',
                    class: "inline-block mx-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Отменить")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}